/**
 * @typedef {Object} Setting
 * @property {string=} name
 * @property {string=} value
 */

/**
 * @typedef {Object} SettingService
 * @property {function(): angular.IPromise<Setting[]>} get
 * @property {function(string): angular.IPromise<Setting>} toggle
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @returns {SettingService}
 */
function bahabotSettingFactory($resource) {
    const Setting = $resource('/api/protected/settings/:name', {}, {
        get:    { method: 'GET' },
        patch:  { method: 'PATCH' },
    });

    const self = {};
    self.get = () => {
        return Setting.get().$promise.then(res => {
            return res.data.map(setting => {

                return {
                    ...setting,
                    value: self.isBooleanSetting(setting.name) ? self.booleanToUniversal(setting.value) : setting.value 
                }
            })
        });
    };

    self.patch = (name, setting) => {
        return Setting.patch({ name }, setting).$promise.then(res => res.data)
    };

    self.isBooleanSetting = (settingName) => {
        const booleanSettings = [
            "var_followthanks-noisy",
            "var_subthanks-noisy",
            "var_bitthanks-noisy",
            "var_raidthanks-noisy",
            "var_faqresponse-noisy"
        ];

        return booleanSettings.includes(settingName);
    };

    self.getExplanation = (settingName) => {
        const explanations = {
            "var_followthanks-noisy": "Whether or not Bahabot will react with a thank-you message for every follow.",
            "var_subthanks-noisy": "Whether or not Bahabot will react with a thank-you message for every subscription. In the case of gift-subs, Bahabot will wait for 15 seconds, and only send one message for all of them.",
            "var_bitthanks-noisy": "Whether or not Bahabot will react with a thank-you message for bits.",
            "var_raidthanks-noisy": "Whether or not Bahabot will react to raids with a thank-you and welcome message, an announcement of the channel link, and a shoutout.",
            "var_followthanks-msg-any": "Message shown when someone follows the channel",
            "var_subthanks-msg-direct-t1-en": "Message shown when someone subscribes at tier 1",
            "var_subthanks-msg-direct-t23-en": "Message shown when someone subscribes at tier 2 or 3",
            "var_subthanks-msg-gift-single-en": "Message shown when someone gifts a single sub to someone",
            "var_subthanks-msg-gift-multi-en": "Message shown when someone gifts multiple subs",
            "var_bitthanks-msg-any": "Message shown when someone sends bits",
            "var_raidthanks-error-general": "Message shown when Bahabot fails to look up the channel of a raiding Twitch User",
            "var_raidthanks-error-announce": "Message shown when Bahabot fails to announce the raiding Twitch User's channel url",
            "var_raidthanks-error-shoutout": "Message shown when Bahabot fails to shoutout the raiding Twitch User's channel",
            "var_raidthanks-msg-ja": "Japanese message shown when Bahabot detects a raid",
            "var_raidthanks-msg-en": "English message shown when Bahabot detects a raid",
            "var_raidthanks-wait": "Message shown when a raid will have to wait to be introduced. Accepts: { Raider: string }",
            "var_faqresponse-noisy": "Whether or not Bahabot will attempt automatically detecting questions answered in the FAQ, and respond to them by linking to the entry in question."
        };

        return explanations[settingName];
    };

    self.settingToType = (settingName) => {
        const types = {
            "var_followthanks-noisy": "boolean",
            "var_subthanks-noisy": "boolean",
            "var_bitthanks-noisy": "boolean",
            "var_raidthanks-noisy": "boolean",
            "var_faqresponse-noisy": "boolean"
        };

        const type = types[settingName];
        if (!type) return "string";
        return type;
    };

    self.booleanToUniversal = (value) => {
        value = value.toLowerCase();
        const truesy = [
            'yes',
            'on',
            '1',
            'y',
            't',
            'true',
        ];

        return truesy.includes(value) ? '1' : '0';
    };

    return self;
}

mod.factory('SettingService', ["$resource", bahabotSettingFactory]);
